import { Scroll } from '../_app/cuchillo/scroll/Scroll';
import Scroll_Item from '../_app/cuchillo/scroll/Scroll_Item';
import Footer from '../layout/Footer';


class ScrollItem__Footer extends Scroll_Item {
    //==================================================================================================================
    //          CONSTRUCTOR
    //==================================================================================================================
    constructor(__link, __index, __scroller) {
        super(__link, __index, __scroller);
      
        this.onShow = () => {
          Footer.show();
        };

        this.onHide = () => {
          Footer.hide();
        };
    }
}

Scroll._registerClass('Footer', ScrollItem__Footer);
